module.exports = __webpack_public_path__ + "static/media/papaya.c1fcdcdb.png";